import { render, staticRenderFns } from "./pintura_video_editor.vue?vue&type=template&id=24f560f7&"
import script from "./pintura_video_editor.vue?vue&type=script&lang=js&"
export * from "./pintura_video_editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports